import shouldRenderLegend, {
	DASHBOARD_WIDGET
} from 'scoreboard/charts/should-render-legend'
import allWidgets from 'scoreboard/dashboards/widgets/all'

function getChartAccessoryMetadata(type) {
	// #58105 include model in the chart accessory metadata for use
	// in chart-widget-view.js
	let model = allWidgets[type]
	if (type === 'chart-color-legend') {
		return {
			model,
			widgetType: 'chart-color-legend',
			chartProperty: 'colorLegendType',
			isEnabled : (chartModel) => shouldRenderLegend(chartModel, DASHBOARD_WIDGET)
		}
	} else if (type === 'chart-table') {
		return {
			model,
			widgetType: 'chart-table',
			chartProperty: 'chartTable',
			isEnabled : (chartModel) => !!chartModel.get('chartTable'),
			defaultAttrs : {
				showSeriesLabel: true,
				showSeriesColor: true,
				showData: true
			}
		}
	}
}

export default getChartAccessoryMetadata
getChartAccessoryMetadata.__filename__ = 'dashboards/widgets/chart/get-chart-accessory-metadata.js'
